<div class="fds-card-root">
  <div class="fds-card__card">
    <div class="fds-card__content fds-card__content--bottom-weighted">
      <fds-content-block fds-align="left" fds-body-full-width>
        <h2
          slot="heading"
          class="fds-content-block__heading fds-content-block__heading--level-4"
        >
          User Agreement
        </h2>
        <div class="user-agreement__content">
          <h3 class="user-agreement__header">Fundsnetwork User Agreement</h3>
          <p>
            This FundsNetwork User Agreement (this "Agreement") governs use of
            the FundsNetwork Site and all FundsNetwork Data accessible through
            the FundsNetwork Site. This Agreement is a binding agreement between
            Fidelity and End User, on End User's own behalf and on behalf of
            Fund/Agent or a third party approved by Fidelity, as applicable. By
            accessing or using the FundsNetwork Site, End User accepts and
            agrees to be bound by the terms and conditions in this Agreement. If
            End User does not agree to the terms and conditions in this
            Agreement, then End User is not authorized to use the FundsNetwork
            Site and should discontinue any use immediately. Access and/or use
            of the FundsNetwork Site is governed by the version of this
            Agreement in effect on the date that End User accesses the
            FundsNetwork Site. Fidelity may modify or amend this Agreement at
            any time without prior notice. End User should review the most
            current version of this Agreement by clicking on the "User
            Agreement" or similar hyperlink located at the bottom of certain
            pages of the FundsNetwork Site. This Agreement is in addition to any
            other agreements between Fund/Agent and any Fidelity Entity,
            including any Services Agreement.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined"
          >
            <span class="user-agreement__section-number">1.</span>
            <span class="user-agreement__section-title">Defined Terms.</span>
          </h3>
          <p>
            "End User" means the individual accepting this Agreement, on its own
            behalf and on behalf of Fund/Agent or an approved third party, as
            applicable, and using the FundsNetwork Site.
          </p>
          <p>
            "Fidelity" means, collectively, Fidelity Brokerage Services LLC,
            National Financial Services LLC and Fidelity Investments
            Institutional Operations Company, Inc., or any successor. Each such
            entity shall be referred to individually herein as a "Fidelity
            Entity".
          </p>
          <p>
            "Fund/Agent" means any entity that is a party to a Services
            Agreement.
          </p>
          <p>
            "FundsNetwork" means Fidelity's investment platform for mutual funds
            and other collective investment vehicles.
          </p>
          <p>
            "FundsNetwork Data" means all content, data, or other information
            that is accessible or otherwise made available through the use of
            the FundsNetwork Site.
          </p>
          <p>
            "FundsNetwork Site" means the FundsNetwork2.com website, or any
            successor website, including all content on or available through
            such website(s).
          </p>
          <p>
            "Services Agreement" means the agreement between Fund/Agent and one
            or more Fidelity Entities that governs the availability of mutual
            funds or other investment products associated with Fund/Agent that
            are held through FundsNetwork.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">2.</span>
            <span class="user-agreement__section-title"
              >Representations, Warranties and Covenants.</span
            >
          </h3>
          <p>
            End User represents, warrants and covenants that (a) End User is an
            authorized representative of Fund/Agent or an authorized
            representative of an approved third party that has an agreement with
            Fund/Agent that governs the use of the FundsNetwork Site and is
            authorized by Fund/Agent to use the FundsNetwork Site; (b) End User
            is authorized by Fund/Agent to accept all of the terms and
            conditions of this Agreement on behalf of Fund/Agent or such third
            party; (c) End User accepts this Agreement on behalf of Fund/Agent
            or such third party; and (d) End User shall use the product in
            conformity with all terms and conditions of this Agreement,
            policies, procedures and guidelines applicable to the use of the
            FundsNetwork Site and the FundsNetwork Data which are communicated
            to Fund/Agent or End User from time to time; (e) End User shall use
            the product and the FundsNetwork Data including any personally
            identifiable information in accordance with all applicable laws
            including all Data Protection Laws; and (f) all acknowledgements and
            representations made herein are true and accurate and Fidelity may
            rely on such representations and acknowledgments without duty of
            inquiry.
          </p>
          <p>
            "Data Protection Laws" means all applicable laws, regulations,
            rules, directives and governmental requirements currently in effect
            and as they become effective relating in any way to the privacy,
            confidentiality or security of personally identifiable information,
            together with any amendments, supplements, and replacements to such
            laws, such as, without limitation, the California Consumer Privacy
            Act of 2018, as amended by the California Privacy Rights Act of 2020
            (together with implementing regulations, collectively, the "CPRA").
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">3.</span>
            <span class="user-agreement__section-title">Scope of Use.</span>
          </h3>
          <p>
            Subject to the terms of this Agreement, Fidelity hereby grants End
            User access to the FundsNetwork Site and FundsNetwork Data, solely
            for the purpose of Fund/Agent's internal business purposes which
            shall include (a) compliance with applicable law, rule or
            regulation; (b) Fund/Agent's performance of its obligations set
            forth in the Services Agreement; and (c) internal analysis of
            FundsNetwork Data.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">4.</span>
            <span class="user-agreement__section-title"
              >Login Credentials.</span
            >
          </h3>
          <p>
            End User shall be responsible for the confidentiality and use of any
            user name, password, access code, or PIN issued to End User or
            Fund/Agent's other employees, representatives or agents
            (collectively, "Login Credentials"). Fund/Agent and End User agree
            that Fidelity may treat as authorized by Fund/Agent any instruction,
            direction or communication which uses Login Credentials and Fidelity
            shall be entitled to rely on and take action based on such
            instructions, directions or communications. Each of Fund/Agent and
            End User understands that Fund/Agent shall be responsible for the
            use of any data, information, or services obtained using such Login
            Credentials. In the event End User or Fund/Agent becomes aware of
            any unauthorized use of Fund/Agent's Login Credentials, Fund/Agent
            shall immediately revoke such Login Credentials and notify Fidelity
            of such unauthorized use. Login Credentials may not be used by
            anyone other than End User and may not be shared or transferred to
            any other individual or entity.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">5.</span>
            <span class="user-agreement__section-title"
              >Restriction on Use; Confidentiality.</span
            >
          </h3>
          <p>
            End User acknowledges and agrees that the FundsNetwork Site,
            including trademarks thereon, and FundsNetwork Data are confidential
            and the proprietary property of Fidelity and its respective
            third-party licensors. End User agrees not to use the FundsNetwork
            Site and FundsNetwork Data except as authorized by Fidelity and, in
            the event that End User is an employee or agent of an approved third
            party, End User will not use the FundsNetwork Site and FundsNetwork
            Data unless prior written authorization from Fidelity is obtained.
            End User agrees to keep confidential and not publish, disclose,
            broadcast, transmit, retransmit, reproduce, sell, commercially
            exploit, isolate, extract and maintain a database of, or network or
            otherwise distribute or redistribute any FundsNetwork Data,
            information, or services provided under this Agreement. To the
            extent End User accesses personally identifiable information through
            the FundsNetwork Site, including contact and transaction data, End
            User will only utilize personally identifiable information or other
            data regarding customers or clients solely to evaluate process and
            administer proposed Fund transactions hereunder unless a Fidelity
            entity expressly agrees in writing otherwise. Notwithstanding, End
            User shall not use or allow any other party to use, process or
            retain any FundsNetwork Data (including personally identifiable
            information) obtained other than for the purpose permitted herein
            and shall not allow any other party to: (a) sell, rent, release,
            disclose, disseminate, make available, transfer, or otherwise
            communicate orally, in writing, or by electronic or other means any
            FundsNetwork Data (including personally identifiable information),
            to any third party, (b) allow any third party to access any
            FundsNetwork Data (including personally identifiable information),
            or (c) deidentify, anonymize or aggregate any FundsNetwork Data
            (including personally identifiable information). In addition, if any
            FundsNetwork Data (including personally identifiable information) or
            other information provided to or obtained by End User pursuant to
            the Services Agreement represents or includes data or information
            that has been deidentified or anonymized, End User shall not (and
            shall not permit or otherwise allow any other party to) re-identify
            such data or attempt to correlate, associate, supplement or
            otherwise process such data or information such that the resulting
            data or information is reasonably capable of identifying or being
            associated or linked with a particular person, household, or device.
          </p>
          <p>
            End User understands that it shall be solely responsible for all use
            of, and actions undertaken on, the FundsNetwork Site. In addition to
            the Indemnification obligations in Section 7 below, End User shall
            defend, indemnify and hold harmless Fidelity and its third party
            service providers, partners, officers, directors, shareholders,
            employees, contractors, representatives, successors and assigns (the
            "Fidelity Indemnitees") from and against any and all third party
            claims, actions and suits arising, alleged, threatened or asserted
            against Fidelity Indemnitees, and any and all associated or
            resulting losses, liabilities, damages, costs, expenses (including
            reasonable attorneys' fees, expert witness fees and awarded
            interest), judgments, regulatory fines and penalties based on or
            arising out of: (i) any violations of the permitted uses and
            restrictions on use of FundsNetwork Data (including personally
            identifiable information) set forth herein by End User or any other
            party, or (ii) the unauthorized use of FundsNetwork Data (including
            personally identifiable information) by End User or any other party,
            and (iii) any breach by End User of the terms of this User
            Agreement.
          </p>
          <p>
            End User agrees that: (i) Fidelity would be subject to potentially
            irreparable injury as a result of any breach of the terms of this
            User Agreement and that monetary damages would not be sufficient to
            compensate or make whole Fidelity for any such breach; and (ii)
            Fidelity, separately or together, shall be entitled to seek
            equitable and injunctive relief, on an emergency, temporary,
            preliminary and/or permanent basis, to prevent any such breach or
            the continuation thereof. Such remedies shall not be the exclusive
            remedies for a breach of this User Agreement but shall be in
            addition to all other remedies available at law or equity to
            Fidelity.
          </p>
          <p>
            End User agrees not to use the FundsNetwork Site except as
            authorized by this Agreement and the Services Agreement and, in any
            event, not to make it available to any third parties unless Fidelity
            has provided prior written authorization. No party shall copy,
            modify, frame-in or provide hyperlinks to any portion of the
            FundsNetwork Site or FundsNetwork Data. End User can access a
            variety of information and reports through the FundsNetwork Site.
            Such information is subject to change at any time and from time to
            time. Use of the FundsNetwork Site may involve the transmission of
            information that may be considered confidential information and is
            subject to the confidentiality provisions in the Services Agreement.
            Fund/Agent hereby consents to the transmission by electronic means
            of such information through the FundsNetwork Site and such consent
            shall be effective at all times that End User uses the FundsNetwork
            Site. Use of the FundsNetwork Site is limited to within the United
            States, and the information within the FundsNetwork Site is only for
            persons in the United States.
          </p>
          <p>
            Fidelity uses cookies to support the operation of the FundsNetwork
            site. Cookies are small amounts of data that a website sends to a
            web browser on a user's computer. Fidelity's cookies are used for
            security purposes, reporting and collecting information regarding
            activity on this website. By using or logging into the FundsNetwork
            site, End User consents to the use of cookies. End Users can refuse
            or delete cookies. Most browsers and mobile devices offer their own
            settings to manage cookies. If End User refuses a cookie when on the
            FundsNetwork site (www.FundsNetwork2.com), or if End User deletes
            cookies, End User may experience some inconvenience in the use of
            the website such as the inability to sign in and access account
            information.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">6.</span>
            <span class="user-agreement__section-title">Notice of Errors.</span>
          </h3>
          <p>
            End User agrees to immediately notify Fidelity if there is any
            discrepancy or error in Fund/Agent data available through the
            FundsNetwork Site or of any other type of discrepancy or suspicious
            or unexplained occurrence relating to the use of the FundsNetwork
            Site. Fidelity will not be responsible for the accuracy,
            completeness, or use of any information received through the
            FundsNetwork Site.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">7.</span>
            <span class="user-agreement__section-title">Indemnification.</span>
          </h3>
          <p>
            Neither Fidelity nor any third-party provider or supplier of market
            data guarantees the timeliness, sequence, accuracy, or completeness
            of the FundsNetwork Data or any other information, or messages
            disseminated by any party. Fidelity shall not be liable in any way,
            and Fund/Agent agrees to indemnify and hold harmless Fidelity from
            and against, any and all claims, demands, actions, losses, damages,
            liability, or costs, charges, counsel fees, and expenses of any
            nature ("Losses") based on, arising out of or otherwise suffered or
            incurred in connection with (a) any inaccuracy, error, or delay in,
            or omission in, the FundsNetwork Site or FundsNetwork Data; or (b)
            the transmission or delivery of any such FundsNetwork Data; or (c)
            any act or omission by a Fidelity Entity that was made in reliance
            on Fund/Agent or End User direction, instructions or communication
            made through the use of the FundsNetwork Site; or (d) its use of the
            FundsNetwork Site or FundsNetwork Data, or from its use of, or
            reliance on any information included in, or omitted from the
            FundsNetwork Site or FundsNetwork Data; or (e) End User's or
            Fund/Agent's violation of this Agreement.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">8.</span>
            <span class="user-agreement__section-title"
              >Modification; Monitoring.</span
            >
          </h3>
          <p>
            Fidelity may modify, change or discontinue the availability of the
            FundsNetwork Site, FundsNetwork Data or any features, functions,
            content, information, reports, data or services available through
            the FundsNetwork Site or FundsNetwork Data in whole or in part, at
            any time. Fidelity may immediately terminate its provision of the
            Services to End User, Fund/Agent or any third party. Fidelity may
            monitor, store and retrieve any electronic communication transmitted
            on the FundsNetwork Site.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">9.</span>
            <span class="user-agreement__section-title"
              >No Offer or Solicitation to Buy Securities.</span
            >
          </h3>
          <p>
            Nothing in the FundsNetwork Site shall be construed as an offer to
            sell, a solicitation of an offer to buy, or a recommendation for any
            security or any other product or service, to any person by Fidelity.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">10.</span>
            <span class="user-agreement__section-title"
              >Governing Law; Notices.</span
            >
          </h3>
          <p>
            This Agreement and its enforcement shall be governed by the laws of
            the Commonwealth of Massachusetts, except with respect to conflicts
            of law, and shall inure to the benefit of Fidelity's successors and
            assigns, whether by merger, consolidation, or otherwise. All notices
            to Fidelity pertaining to this Agreement should be sent directly to
            Fidelity in accordance with the notice provisions of the Services
            Agreement.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">11.</span>
            <span class="user-agreement__section-title"
              >Fees, Charges or Expenses.</span
            >
          </h3>
          <p>
            End User agrees to be liable for any and all fees, charges or
            expenses incurred in connection with the use of the FundsNetwork
            Site by it or by any other person through use of Fund/Agent's
            security codes, equipment, or otherwise.
          </p>

          <h3 class="user-agreement__section-heading">
            <span class="user-agreement__section-number">12.</span>
            <span class="user-agreement__section-title"
              >DISCLAIMER OF WARRANTIES</span
            >
          </h3>
          <p>
            FIDELITY AND ITS THIRD-PARTY PROVIDERS AND SUPPLIERS DO NOT MAKE ANY
            EXPRESS OR IMPLIED WARRANTIES ABOUT THE FUNDSNETWORK SITE OR THE
            FUNDSNETWORK DATA, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES
            OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
            NON-INFRINGEMENT. THE FUNDSNETWORK SITE AND FUNDSNETWORK DATA ARE
            MADE AVAILABLE TO YOU "AS IS" AND "AS AVAILABLE" AND FIDELITY DOES
            NOT WARRANT THAT ANY DEFECTS OR INACCURACIES WILL BE CORRECTED.
          </p>
          <p>
            FIDELITY AND ITS THIRD-PARTY PROVIDERS AND SUPPLIERS DO NOT WARRANT
            THAT THE FUNDSNETWORK SITE OR FUNDSNETWORK DATA WILL MEET END USER'S
            OR FUND/AGENT'S NEEDS, OR THAT IT WILL BE UNINTERRUPTED, TIMELY,
            COMPLETE, SECURE OR ERROR-FREE. FIDELITY ALSO MAKES NO WARRANTY THAT
            THE RESULTS OBTAINED FROM THE USE OF THE FUNDSNETWORK SITE OR
            FUNDSNETWORK DATA WILL BE ACCURATE, COMPLETE OR RELIABLE, OR WILL
            MEET END USER'S OR FUND/AGENT'S EXPECTATIONS.
          </p>

          <h3 class="user-agreement__section-heading">
            <span class="user-agreement__section-number">13.</span>
            <span class="user-agreement__section-title"
              >LIMITATION OF LIABILITY</span
            >
          </h3>
          <p>
            EACH OF END USER AND FUND/AGENT EXPRESSLY ACKNOWLEDGES AND AGREES
            THAT ITS USE OF FUNDSNETWORK DATA AND THE FUNDSNETWORK SITE IS AT
            FUND/AGENT'S AND END USER'S SOLE RISK AND RESPONSIBILITY.
          </p>
          <p>
            FIDELITY WILL NOT BE LIABLE TO END USER, FUND/AGENT OR ANY THIRD
            PARTY FOR ANY CONSEQUENTIAL, INCIDENTAL, SPECIAL, DIRECT, OR
            INDIRECT DAMAGES (INCLUDING BUT NOT LIMITED TO LOST PROFITS, TRADING
            LOSSES OR DAMAGES THAT RESULT FROM USE OR LOSS OF USE OF THE
            FUNDSNETWORK SITE, THE FUNDSNETWORK DATA OR ANY THIRDPARTY CONTENT,
            INCONVENIENCE OR DELAY). THIS IS TRUE EVEN IF FIDELITY HAS BEEN
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR LOSSES.
          </p>
          <p>
            FIDELITY WILL NOT BE LIABLE TO END USER OR FUND/AGENT OR ANYONE ELSE
            FOR ANY LOSS RESULTING FROM A CAUSE OVER WHICH FIDELITY DOES NOT
            HAVE DIRECT CONTROL. THIS INCLUDES FAILURE OF ELECTRONIC OR
            MECHANICAL EQUIPMENT OR COMMUNICATIONS LINES (INCLUDING TELEPHONE,
            CABLE AND INTERNET), UNAUTHORIZED ACCESS, VIRUSES, THEFT, OPERATOR
            ERRORS, SEVERE OR EXTRAORDINARY WEATHER (INCLUDING FLOOD,
            EARTHQUAKE, OR OTHER ACT OF GOD), FIRE, WAR, INSURRECTION, TERRORIST
            ACT, RIOT, LABOR DISPUTE AND OTHER LABOR PROBLEMS, ACCIDENT,
            EMERGENCY OR ACTION OF GOVERNMENT.
          </p>
          <p>
            IF END USER LIVES IN A STATE THAT DOES NOT ALLOW THE LIMITATION OR
            EXCLUSION OF LIABILITY OR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SOME
            OR ALL OF THESE LIMITATIONS AND EXCLUSIONS MAY NOT APPLY TO YOU.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">14.</span>
            <span class="user-agreement__section-title">Severability.</span>
          </h3>
          <p>
            If a court of competent jurisdiction deems any provision of this
            Agreement unenforceable, that provision will be enforced to the
            maximum extent permissible, and the remaining provisions will remain
            in full force and effect.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">15.</span>
            <span class="user-agreement__section-title">CUSIP Notice.</span>
          </h3>
          <p>
            "CUSIP" identifiers have been provided by CUSIP Global Services,
            managed on behalf of the American Bankers Association by FactSet
            Research Systems Inc., and are not for use or dissemination in a
            manner that would serve as a substitute for any CUSIP service. The
            CUSIP Database, &copy; 2026 CUSIP Global Services. "CUSIP" is a
            registered trademark of the American Bankers Association.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">16.</span>
            <span class="user-agreement__section-title">Server Capacity.</span>
          </h3>
          <p>
            Because all servers have limited capacity and are used by many
            people, End User shall not use the FundsNetwork Site in any manner
            that could damage or overburden any Fidelity server, or any network
            connected to any Fidelity server. End User shall not use the
            FundsNetwork Site in any manner that would interfere with any other
            party's use of the FundsNetwork Site.
          </p>

          <h3
            class="user-agreement__section-heading user-agreement__section-heading--underlined user-agreement__section-heading--inline"
          >
            <span class="user-agreement__section-number">17.</span>
            <span class="user-agreement__section-title"
              >Termination; Modification; Suspension.</span
            >
          </h3>
          <p>
            Fidelity may modify, suspend or terminate access to the FundsNetwork
            Site or the FundsNetwork Data at any time and with respect to any
            party upon Fidelity's sole discretion or terminate this Agreement at
            any time upon notice to Fund/Agent.
          </p>

          <p class="user-agreement__modified-date">
            This Agreement was last modified September 1, 2026.
          </p>
          <p class="user-agreement__version">655948.6.0</p>
        </div>

        @if (showActions) {
          <div class="user-agreement__actions">
            <fds-checkbox
              fds-checkbox-control
              [(ngModel)]="isAgreed"
              fds-text="I have read and accept this User Agreement"
            ></fds-checkbox>

            <fds-button
              (click)="onContinue()"
              [attr.fds-disabled]="!isAgreed"
              class="user-agreement__accept-btn"
            >
              Continue
            </fds-button>
          </div>
        }
      </fds-content-block>
    </div>
  </div>
</div>
